import __request__ from "routing/request";
export function defaultPrompt(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/investigations/summary/prompt", null, {}, {
    "Accept": ["text/plain"]
  }, requestOptions);
}
export function prompt(templateName, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/summary/prompt/${templateName}`, null, {}, {
    "Accept": ["text/plain"]
  }, requestOptions);
}
export function summary(investigationId, JSONBody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp/investigations/summary/${investigationId}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function investigationReport(investigationId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/summary/${investigationId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
